import React from 'react';
import PropTypes from 'prop-types';
import usePortfolioStyles from '../../assets/css/_portfolio';

const MarqueeRow = ({ items, classes, direction }) => {
  // Duplicate the items so the loop is seamless when transform reaches -50%.
  const sequence = [...items, ...items];

  return (
    <div className={classes.marqueeRow}>
      <div
        className={`${classes.marqueeTrack} ${
          direction === 'right' ? classes.marqueeTrackReverse : ''
        }`}
      >
        {sequence.map((portfolio, idx) => {
          const interactive = Boolean(portfolio.link);
          const logo = (
            <img
              src={require('assets/portfolio/' + portfolio.logo)}
              alt={portfolio.title}
              className={classes.marqueeLogo}
              loading="lazy"
            />
          );

          return (
            <div className={classes.marqueeItem} key={`${portfolio.title}-${idx}`}>
              {interactive ? (
                <a
                  href={portfolio.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.marqueeLink}
                  aria-label={`Visit ${portfolio.title}`}
                >
                  {logo}
                </a>
              ) : (
                logo
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const BorderSpark = ({ classes }) => (
  <div className={classes.borderSpark} aria-hidden="true">
    <span className={classes.sparkOrbiter}>
      <svg
        className={classes.sparkStar}
        width="220"
        height="50"
        viewBox="0 0 220 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="cybrosCometTail" x1="0%" y1="50%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="#4079bf" stopOpacity="0" />
            <stop offset="48%" stopColor="#4079bf" stopOpacity="0.55" />
            <stop offset="82%" stopColor="#a4fbe0" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0.95" />
          </linearGradient>
          <radialGradient id="cybrosCometBloom" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95" />
            <stop offset="28%" stopColor="#4df4bd" stopOpacity="0.55" />
            <stop offset="65%" stopColor="#4df4bd" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#4df4bd" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Slim tapered tail */}
        <path
          d="M 4 25 C 60 22 130 21 178 23.5 L 182 25 L 178 26.5 C 130 29 60 28 4 25 Z"
          fill="url(#cybrosCometTail)"
        />
        {/* Subtle silver edge along the bright half of the tail */}
        <path
          d="M 80 23.4 C 130 22.4 165 22 178 23"
          stroke="#e4e9ee"
          strokeOpacity="0.55"
          strokeWidth="0.4"
          fill="none"
        />

        {/* Soft mint bloom behind the Cybros favicon */}
        <circle cx="185" cy="25" r="22" fill="url(#cybrosCometBloom)" />

        {/* Cybros favicon as the comet head */}
        <image
          href="/favicon.ico"
          x="170"
          y="10"
          width="30"
          height="30"
          preserveAspectRatio="xMidYMid meet"
        />
      </svg>
    </span>
  </div>
);

export default function PortfolioItem(props) {
  const classes = usePortfolioStyles();
  const { portfolioItem } = props;

  const half = Math.ceil(portfolioItem.length / 2);
  const topRow = portfolioItem.slice(0, half);
  const bottomRow = portfolioItem.slice(half);

  return (
    <div className={classes.marqueeStage}>
      <BorderSpark classes={classes} />
      <div className={classes.marqueeWrap}>
        <MarqueeRow items={topRow} classes={classes} direction="left" />
        {bottomRow.length > 0 && (
          <MarqueeRow items={bottomRow} classes={classes} direction="right" />
        )}
      </div>
    </div>
  );
}

PortfolioItem.propTypes = {
  portfolioItem: PropTypes.array,
};
